import CrmPage from "@/app/crm/pages/CrmPage.vue";
import ContactsPage from "@/app/contacts/pages/ContactsPage.vue";
import TicketsManagerPage from "@/app/ticketsManager/pages/TicketsManagerPage.vue";
import ImportsTemplate from "@/app/imports/components/templates/ImportsTemplate.vue";
import EmailsManagerPage from "@/app/emailsManager/pages/EmailsManagerPage.vue";
import TemplatesTemplate from "@/app/imports/components/templates/TemplatesTemplate.vue";
import TemplatesClientTemplate from "@/app/imports/components/templates/TemplatesClientTemplate.vue";
import TemplatesProductTemplate from "@/app/imports/components/templates/TemplatesProductTemplate.vue";

export default [
  {
    path: "/crm",
    name: "crm",
    component: CrmPage,
    redirect: "/crm/contacts",
    children: [
      {
        path: "contacts",
        component: ContactsPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "tickets-manager",
        component: TicketsManagerPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "imports",
        component: ImportsTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "emails-manager",
        component: EmailsManagerPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "templates",
        component: TemplatesTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "templates/edit-contacts",
        component: TemplatesClientTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "templates/edit-product",
        component: TemplatesProductTemplate,
        meta: {
          requiresAuth: true,
        },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/imports",
  //   name: "imports",
  //   component: () =>
  //     import("@/app/imports/pages/ImportsPage"),
  //   redirect: "/imports/board",
  //   children: [

  //   ],
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
];
